import axios, { AxiosRequestConfig } from 'axios';

import { CustomerUser, TokenProps } from '../models/auth';
import { getRefreshToken, getUserInfo } from '../client/auth';
import { navigateToScreen } from './authService';

export const createCustomerTokenProvider = () => {
  let customerAccess: TokenProps = {
    token: undefined,
    refreshToken: undefined,
  };
  let unparsedCustomerAuthToken = localStorage.getItem('CUSTOMER_TOKEN');

  if (unparsedCustomerAuthToken) {
    customerAccess = JSON.parse(unparsedCustomerAuthToken);
  }

  const getExpirationDate = (jwToken?: string | null): number | null => {
    if (!jwToken) {
      return null;
    }

    const jwt = JSON.parse(atob(jwToken.split('.')[1]));
    return (jwt && jwt.exp && jwt.exp * 1000) || null;
  };

  const getCustomerUser = async (): Promise<CustomerUser | null> => {
    var userInfoResponse = await getUserInfo();
    if(!userInfoResponse.error) {
      return userInfoResponse;
    } else {
      return {displayName: '', role: '', email: '', sessionExpires: ''};
    }
  };

  const isExpired = (exp: number | null) => {
    if (!exp) {
      return false;
    }
    return Date.now() > exp;
  };

  const isTokenExpired = () => {
    if (!customerAccess) {
      return null;
    }

    if (isExpired(getExpirationDate(customerAccess.token))) {
      return true;
    } else {
      return false;
    }
  };

  const getToken = async (email?: string | null) => {
    if (!customerAccess) {
      return null;
    }

    if (isExpired(getExpirationDate(customerAccess.token))) {
      email = email || '';
      const refreshTokenResponse = await getRefreshToken({...customerAccess, email});
      if (!refreshTokenResponse.error) {
        setToken(refreshTokenResponse);
      } else {
        const lang = localStorage.getItem('language');
        localStorage.clear();
        localStorage.setItem('language', lang || 'de-DE');
        navigateToScreen('/login');

      }
    }
    return customerAccess && customerAccess.token;
  };

  const isLoggedIn = () => {
    if (!customerAccess) {
      return false;
    }
    return !!customerAccess.token;
  };

  const setToken = (token: typeof customerAccess) => {
    if (token) {
      localStorage.setItem('CUSTOMER_TOKEN', JSON.stringify(token));
    } else {
      localStorage.removeItem('CUSTOMER_TOKEN');
      localStorage.removeItem('Customer');
    }
    customerAccess = token;
  };

  return {
    getToken,
    isLoggedIn,
    setToken,
    getCustomerUser,
    isTokenExpired,
  };
};